import { createApi } from "@saas/api-client";

export const api = createApi("owner");
